import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { useQuery } from '@tanstack/react-query'

/** Store builds that predate @capacitor/app can't report a version, so they count as '0'. */
export function useInstalledAppVersion() {
  return useQuery({
    queryKey: ['installedAppVersion'],
    queryFn: async () =>
      Capacitor.isPluginAvailable('App') ? (await App.getInfo()).version : '0',
    enabled: Capacitor.isNativePlatform(),
    staleTime: Infinity,
    retry: false,
  })
}
